<template>
    <v-container fluid px-4 py-0 pt-1 grid-list-lg>
        <v-layout row wrap px-4 py-0 pt-1>
            <v-flex xs12></v-flex>
            <v-flex xs12>
                <h3>Dashboard</h3>
            </v-flex>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        Assigned to Your Office
                        <v-spacer></v-spacer>
                        <v-text-field v-model="userSearch" append-icon="search" label="Filter" single-line hide-details></v-text-field>
                    </v-card-title>
                    <loader v-show="isUserLoading" :small="true"></loader>
                    <v-data-table v-show="!isUserLoading" :headers="headers" :items="userDashboard" :search="userSearch"
                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]" :pagination.sync="pagination">
                        <template slot="items" slot-scope="props">
                            <td class="text-xs pl-2 pr-1"><v-btn icon @click="viewItem(props.item)"><v-icon>assignment</v-icon></v-btn></td>
                            <td class="text-xs pa-1">{{ props.item.workflowDescription }}</td>
                            <td class="text-xs pa-1">{{ props.item.workflowStatusDescription }}</td>
                            <td class="text-xs pa-1">{{ props.item.medicalStatus }}</td>
                            <td class="text-xs pa-1">{{ props.item.altCaseNumber }}</td>
                            <td class="text-xs pa-1">{{ props.item.fullName }}</td>
                            <td class="text-xs pa-1">{{ props.item.createdDate }}</td>
                            <td class="text-xs pa-1">{{ props.item.durationInDays }}</td>
                            <template v-if="props.item.workflowId >= 8000">
                                <td class="caption pr-0 pl-1">
                                    <span style="font-size: 13px;">{{props.item.coronerUsername}}</span>
                                </td>
                            </template>
                            <template v-else>
                                <td class="caption pr-0 pl-1">
                                    <v-select style="font-size: 13px;" dense clearable single-line v-model="props.item.coronerUserId" :items="assignableUserList" item-text="username"
                                        item-value="userId" placeholder="None">
                                    </v-select>
                                </td>
                                <td class="caption pa-0">
                                    <v-btn color="primary" style="min-width: 0px; padding: 0 8px;" @click="assignCoronerUser(props.item)">Assign</v-btn>
                                </td>
                            </template>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        Assigned to Others
                        <v-spacer></v-spacer>
                        <v-text-field v-model="otherSearch" append-icon="search" label="Filter" single-line hide-details></v-text-field>
                    </v-card-title>
                    <loader v-show="isOtherLoading" :small="true"></loader>
                    <v-data-table v-show="!isOtherLoading" :headers="otherHeaders" :items="otherDashboard" :search="otherSearch"
                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]" :pagination.sync="pagination">
                        <template slot="items" slot-scope="props">
                            <td class="text-xs"><v-btn icon @click="viewItem(props.item)"><v-icon>assignment</v-icon></v-btn></td>
                            <td class="text-xs">{{ props.item.workflowDescription }}</td>
                            <td class="text-xs">{{ props.item.workflowStatusDescription }}</td>
                            <td class="text-xs">{{ props.item.altCaseNumber }}</td>
                            <td class="text-xs">{{ props.item.fullName }}</td>
                            <td class="text-xs">{{ props.item.createdDate }}</td>
                            <td class="text-xs">{{ props.item.durationInDays }}</td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import loader from '@/components/Loader'
import dashboardService from '@/services/dashboardService'
import workflowService from '@/services/workflowService'
import userService from '@/services/userService'
import caseNarrativeService from '@/services/caseNarrativeService'

export default {
    components: {
        loader
    },
    props: {
        coronerUserDto: {}
    },
    data: function () {
        return {
            isUserLoading: false,
            isOtherLoading: false,
            workflowEnum: workflowService.WorkflowEnum,
            userSearch: '',
            otherSearch: '',
            otherHeaders: [
                { text: 'View', sortable: 'false', value: 'caseId' },
                { text: 'Workflow', value: 'workflowDescription' },
                { text: 'Status', value: 'workflowStatusDescription' },
                { text: 'Case Number', value: 'caseNumber' },
                { text: 'Name', value: 'fullName' },
                { text: 'Status Date', value: 'createdDate' },
                { text: 'Days', value: 'durationInDays' }
            ],
            userDashboard: [],
            otherDashboard: [],
            assignableUserList: [],
            pagination: {
                rowsPerPage: 100
            }
        }
    },
    computed: {
        isCoroner: function () {
            return (this.coronerUserDto && (userService.isCoroner(this.coronerUserDto.roleList) || userService.isAdministrator(this.coronerUserDto.roleList)))
        },
        headers: function () {
            var headers = [
                { text: 'View', sortable: 'false', value: 'caseId', class: 'pl-2 pr-1' },
                { text: 'Workflow', value: 'workflowDescription', class: 'pa-1' },
                { text: 'Status', value: 'workflowStatusDescription', class: 'pa-1' },
                { text: 'Medical Status', value: 'medicalStatus', class: 'pa-1' },
                { text: 'Case Number', value: 'caseNumber', class: 'pa-1' },
                { text: 'Name', value: 'fullName', class: 'pa-1' },
                { text: 'Status Date', value: 'createdDate', class: 'pa-1' },
                { text: 'Days', value: 'durationInDays', class: 'pa-1' }
            ]
            if (this.isCoroner) {
                headers.push({ text: 'Assigned Coroner', value: 'assignedCoronerUserId', class: 'pa-1' })
            }
            return headers
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        log (message) {
            return loggingService.log(this.isDebug, 'Dashboard', message)
        },
        loadData () {
            this.isUserLoading = true
            this.isOtherLoading = true
            var promises = [
                dashboardService.listDashboardResults(this.$http),
                dashboardService.listDashboardCoronerOthers(this.$http)
            ]
            Promise.all(promises).then(responses => {
                this.userDashboard = responses[0].data
                this.otherDashboard = responses[1].data
                this.isUserLoading = false
                this.isOtherLoading = false
                //load assignable user list
                if (this.isCoroner) {
                    userService.listUserCountyCoroners(this.$http).then(respUser => {
                        this.assignableUserList = respUser.data
                    })
                }
            })
            // dashboardService.listDashboardResults(this.$http).then(response => {
            //     this.userDashboard = response.data
            //     this.isUserLoading = false
            // })
            // dashboardService.listDashboardCoronerOthers(this.$http).then(response => {
            //     this.otherDashboard = response.data
            //     this.isOtherLoading = false
            // })
        },
        viewItem (item) {
            // if (item.workflowId === this.workflowEnum.CaseInitial) {
            //     this.$router.push('/Case/' + item.caseId)
            // }
            this.$router.push('/Case/' + item.caseId)
        },
        assignCoronerUser (item) {
            this.isUserLoading = true
            //regular workflow
            if (item.workflowId !== 7000) {
                var dto = {
                    workflowId: item.workflowId,
                    parentId: item.moduleId,
                    coronerUserId: item.coronerUserId
                }
                workflowService.assignCoronerUser(this.$http, dto).then(response => {
                    this.loadData()
                })
            //case narrative workflow
            } else {
                var narrativeDto = {
                    caseId: item.caseId,
                    caseNarrativeId: item.moduleId,
                    userId: item.coronerUserId
                }
                if (item.workflowStatusDescription === 'Pending Finalized Narrative') {
                    caseNarrativeService.reassignNarrative(this.$http, narrativeDto).then(response => {
                        if (!response.data.isValid) {
                            alert(response.data.messages.join('\n'))
                        }
                        this.loadData()
                    })
                } else if (item.workflowStatusDescription === 'Pending Assignment') {
                    caseNarrativeService.assignAndCreate(this.$http, narrativeDto).then(response => {
                        if (!response.data.isValid) {
                            alert(response.data.messages.join('\n'))
                        }
                        this.loadData()
                    })
                }
            }
        }
    }
}
</script>
